"use client";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import toolsImg from "../../Assets/tools-img.png";
import messageIcon from "../../Assets/message-icon.png";
import quotatino_img from "../../Assets/images/quotation.png"
import manufacture_img from "../../Assets/images/manufacture.png"
import product_img from "../../Assets/images/settings.png"
import axios from "axios";
import "../../App.css";
import SearchableSelect from "../../Components/SerachableSelect";

export default function Sidebar() {
  const [types, setTypes] = useState([]);
  const [activeTool, setActiveTool] = useState(null);
  const token = JSON.parse(localStorage.getItem("mmt_front_token"));
  const idToken = token?.idToken;
  const navigate = useNavigate();
  const user_details=JSON.parse(localStorage.getItem('user_details'));
  // console.log("user_details",user_details);



  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}tool_type/all-types`, {
        headers: {
          "X-ID-TOKEN": idToken,
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      })
      .then((res) => {
        setTypes(res.data.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  const handle_onchange2 = (attributeName, value, option) => {
    console.log(`attributeName`, attributeName);

     
    if(option !==null){
      setActiveTool(option.uuid);
      navigate(`/${option.uuid}`);
    
    }else{
      navigate(`/dashboard`); 

    }
    
   
  };
  return (
    <aside
      className={` inset-y-0 left-0 w-81 bg-white shadow-lg py-2 px-2  h-full overflow-y-auto `}
      style={{ height: "100%", borderRight: "2px solid #f3f4f6" }}
    >
      <div className="p-2">
        {/* <div className="mb-4">
        <div className="text-base mt-2"> Create Quotation </div>
          <SearchableSelect
            item={{
              attribute_name: "Search by tool type",
              attribute_value: types.map((item) => {
                let obj = { ...item, name: item.tool_type_name };
                return obj;
              }),
            }}
            handle_onchange={handle_onchange2}
            placeholder={"Please select tool type"}
          />
        </div> */}
        <div className="text-xl mt-2 border-t border-gray-400 pb-2  inter flex gap-2 items-center text-center cursor-pointer"
         
         onClick={() => {
           navigate("/quotation");
         }}
        >
          <div
           className="mt-2"
          >
            {" "}
            <img src={quotatino_img} width={50} height={60} alt="" />{" "}
          </div>
          <div className="text-base mt-2"> My Quotations </div>
        </div>
        <div className="text-xl  border-t border-gray-400 pb-2  inter flex gap-2 items-center cursor-pointer"
        onClick={() => {
          navigate("/products");
        }}
        >
          <div
            className=" mt-2"
            
          >
            {" "}
            <img src={manufacture_img} width={50} height={60} alt="" />{" "}
          </div>
          <div className="text-base mt-2">Add New Products </div>
        </div>
        <div className="text-xl  border-t border-gray-400 pb-2  inter flex gap-2 items-center cursor-pointer "
         onClick={() => {
          navigate("/my_products");
        }}
        >
          <div
            className=" mt-2"
           
          >
            {" "}
            <img src={product_img} width={50} height={60} alt="" />{" "}
          </div>
          <div className="text-base mt-2">My Products </div>
        </div>


        {/* <div className="text-xl pb-3 mb-3 border-b border-gray-300 inter"> */}
        {/* <label className="text-xs text-gray-500">
              {" "}
              Search by Tool ID{" "}
            </label>
            <input
              type="text"
              placeholder="Id"
              className=" border border-gray-300 w-full text-black bg-white px-2 text-sm h-10 rounded-sm"
            /> */}

        {/* </div> */}

        {/* <div className="text-xl pb-3 mb-3 inter">
            {types.length>0?types?.map((type, index) => (
             
              <NavLink to={`/${type.uuid}`}>
                <a
                  className={activeTool==type.uuid?`flex activeToolCat text-black p-3 rounded-md items-center gap-2  mb-2`:`flex bg-white text-black p-3 rounded-md items-center gap-2 nonActiveToolCat mb-2`}
                  key={index}
                  onClick={()=>{
                    console.log("clicked");
                    setActiveTool(type.uuid)
                  }}
                >
                
                  <div className="text-sm "> {type.tool_type_name} </div>
                </a>
              </NavLink>
             
            )):null}
            
          </div> */}
      </div>
    </aside>
  );
}
